import Header from "../../components/seller-hub/header/Header";
import Seller from "../../layouts/seller-hub/Seller";
import Card from "../../components/seller-hub/wallet/Card";
import Table from "../../components/seller-hub/overview/Table";
import TableRow from "../../components/seller-hub/overview/TableRow";
import Chart from "../../components/seller-hub/overview/Chart";
import Button from "../../components/seller-hub/buttons/Button";

const SellerOverview = () => {
  const dummyArr = [
    {
      date: "17/05/2022",
      referenceId: "Qwerty5000",
      itemname: "Black Jeans",
      status: "Successful",
    },
    {
      date: "17/05/2022",
      referenceId: "Qwerty5000",
      itemname: "Black Jeans",
      status: "Pending",
    },
    {
      date: "17/05/2022",
      referenceId: "Qwerty5000",
      itemname: "Black Jeans",
      status: "Pending",
    },
    {
      date: "17/05/2022",
      referenceId: "Qwerty5000",
      itemname: "Black Jeans",
      status: "Failed",
    },
  ];
  return (
    <div className="-mt-20 w-full pb-5">
      <Header />
      <Seller>
        <div className="mt-4">
          <h4 className="font-Lato font-bold text-xl">Overview</h4>
          <div className="mt-5 flex gap-3 flex-wrap">
            <Card
              headerText="Quantity Uploaded"
              amount="100"
              dropdown={false}
              height="h-[135px]"
            />
            <Card
              headerText="Quantity Sold"
              amount="60"
              dropdown={false}
              height="h-[135px]"
            />
            <Card
              headerText="Pending Approval"
              amount="5"
              dropdown={false}
              height="h-[135px]"
            />
          </div>
        </div>

        <Chart text="Sales activity - Last 30 days" />

        <div className="mt-8 pt-2 border-[0.5px]  rounded-tr rounded-tl border-[#DEE2F3] ">
          <h4 className="text-lg font-Lato font-bold pl-2">
            Recent Activities
          </h4>
          <div className="overflow-scroll xl:overflow-auto scrollbar-none">
            <div className="w-[820px] xl:w-auto">
              <div className="mt-3 pl-2">
                <Table />
              </div>
              <div className="">
                {dummyArr.map((arr, index) => (
                  <TableRow
                    key={Math.random()}
                    data={arr}
                    index={index}
                    // targetedIndex={targetIndex}
                    // arr={dummyArr.length}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-5">
          <Button
            width="w-[129px]"
            innerText="New Item"
            icon={[
              <svg
                key={Math.random()}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-plus-square w-6 h-6"
                viewBox="0 0 16 16"
              >
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
            ]}
          />
        </div>
      </Seller>
    </div>
  );
};

export default SellerOverview;
